import { Radio, RadioGroup } from '@trackman/web-shared-components';

import { AppButton } from 'components/form';
import { t } from 'utilities/TranslationUtils';
import { useState } from 'react';

type RadioFilterProps = {
  filter: { options: any[]; type: string; selectProps?: any; label?: string };
  onApply: (value?: any) => void;
};

export const RadioFilter = ({ filter, onApply }: RadioFilterProps) => {
  const [value, setValue] = useState<string | number | undefined>();

  return (
    <div className='data-table-filter-content gap-10px'>
      <RadioGroup
        onChange={(e) => {
          setValue(e.target.value);
        }}
        onKeyDown={(e) => e.key === 'Enter' && onApply(value)}
        value={value}
      >
        {filter.options.map((c, i) => (
          <div key={i} style={{ padding: '0 16px', borderRadius: 8, border: '1px solid #e0e0e0' }}>
            <Radio
              reversed
              data-test={`radio-${c.label?.replace(/\s/g, '')}`}
              {...c}
              checked={c.value === value}
              margin='3px'
              width={'100%'}
            />
          </div>
        ))}
      </RadioGroup>

      <AppButton data-test='ApplyFilterSubmit' type='button' className='apply-button ' variant='primary' onClick={() => onApply(value)}>
        {t('common.apply')}
      </AppButton>
    </div>
  );
};

export default RadioFilter;
